<div id="chartDesigner" style="height: 100%; margin-top: -14px;"></div>